import api from "./api";

export function getOpenAccountPage(country_id) {
  return api.get(`/bankaccountpage/${country_id}`);
}

export function getBankAccounts(page = 1, limit = 10, country_id) {
  return api.get(`/banks?page=${page}&limit=${limit}&country_id${country_id}`);
}
